;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.question-templates', []).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.question-templates', {
      url: '/question-templates?pages&filters',
      templateUrl: 'question-templates.template.html',
      controller: 'QuestionTemplates',
    })
  }
})()
